"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Languages_1 = __importDefault(require("../Languages"));
var ProfileMenuList_1 = __importDefault(require("../ProfileMenuList"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var UnAuthProfileMenu = function (_a) {
    var _b;
    var languages = _a.languages, defaultCurrency = _a.defaultCurrency, firstDepMaxBonus = _a.firstDepMaxBonus, firstDepFreespins = _a.firstDepFreespins, WelcomeProfileBanner = _a.WelcomeProfileBanner, promoLink = _a.promoLink;
    var openSignIn = (0, apps_shared_1.useOpenSignIn)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var openManager = (0, common_hooks_1.usePremiumSupport)().openManager;
    var config = (0, swr_hooks_1.useConfig)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var first = (0, swr_hooks_1.useCalculateWelcomePackage)().first;
    var secondaryMenuList = (0, react_1.useMemo)(function () {
        var _a;
        var defaultList = [
            {
                label: t('promotions'),
                icon: '/img/profileMenu/bonuses.svg',
                iconActive: '/img/profileMenu/bonusesActive.svg',
                href: generateUrlWithLang('/promotions'),
            },
            {
                label: t('tournaments'),
                slug: 'tournaments',
                icon: '/img/profileMenu/tournaments.svg',
                iconActive: '/img/profileMenu/tournamentsActive.svg',
                href: generateUrlWithLang('/tournaments'),
            },
            {
                label: t('vipclub'),
                icon: '/img/profileMenu/vip.svg',
                iconActive: '/img/profileMenu/vipActive.svg',
                href: generateUrlWithLang('/vip'),
            },
        ];
        var filteredList = (config === null || config === void 0 ? void 0 : config.hideTournaments)
            ? defaultList.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.slug) !== 'tournaments'; })
            : defaultList;
        if (!(config === null || config === void 0 ? void 0 : config.disablePaymentsLink))
            defaultList.push({
                label: t('payments'),
                icon: '/img/profileMenu/bank.svg',
                iconActive: '/img/profileMenu/bankActive.svg',
                href: generateUrlWithLang('/payments'),
            });
        if (config === null || config === void 0 ? void 0 : config.additionalPages) {
            var additionalPages = (_a = config === null || config === void 0 ? void 0 : config.additionalPages) === null || _a === void 0 ? void 0 : _a.map(function (link) { return ({
                label: link.name,
                icon: link === null || link === void 0 ? void 0 : link.icon,
                href: link.link,
            }); });
            return __spreadArray(__spreadArray([], additionalPages, true), filteredList, true);
        }
        return promoLink
            ? __spreadArray([
                {
                    label: t('promo'),
                    icon: '/img/promo/bonusIcon.svg',
                    href: generateUrlWithLang(promoLink),
                }
            ], filteredList, true) : filteredList;
    }, [promoLink, t, generateUrlWithLang, config]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.closeIcon },
            react_1.default.createElement(ui_components_1.CloseIcon, { onClickHandler: closeWindow })),
        react_1.default.createElement("nav", { className: styles_module_scss_1.default.menu },
            (config === null || config === void 0 ? void 0 : config.withSportInBurger) && (react_1.default.createElement(ProfileMenuList_1.default, { haveBalance: false, items: [
                    {
                        label: t('sport'),
                        icon: '/img/profileMenu/sport.svg',
                        iconActive: '/img/profileMenu/sportActive.svg',
                        href: generateUrlWithLang('/betting/sports/live'),
                    },
                ] })),
            react_1.default.createElement(ProfileMenuList_1.default, { haveBalance: false, items: [
                    {
                        label: "".concat(t('top'), " ").concat(t('games')),
                        icon: '/img/profileMenu/topGames.svg',
                        iconActive: '/img/profileMenu/topGamesActive.svg',
                        href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.profileMenuTopGamesPageSlug)
                            ? config === null || config === void 0 ? void 0 : config.profileMenuTopGamesPageSlug
                            : '/games/top'),
                    },
                    {
                        label: "".concat(t('new'), " ").concat(t('games')),
                        icon: '/img/profileMenu/newGames.svg',
                        iconActive: '/img/profileMenu/newGamesActive.svg',
                        href: generateUrlWithLang('/games/new'),
                    },
                ] }),
            react_1.default.createElement(ProfileMenuList_1.default, { items: secondaryMenuList }),
            react_1.default.createElement(ProfileMenuList_1.default, { secondary: true, items: [
                    {
                        label: t('termsOfUse'),
                        icon: '/img/profileMenu/terms.svg',
                        iconActive: '/img/profileMenu/terms.svg',
                        href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'),
                        target: '_blank',
                        langs: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ] }),
            !(config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.supportWrapper },
                react_1.default.createElement("div", { onClick: openManager, className: styles_module_scss_1.default.support },
                    react_1.default.createElement("img", { src: "/img/profileMenu/support.svg", alt: "Account" }),
                    react_1.default.createElement("span", null, t('support')))))),
        WelcomeProfileBanner ? (react_1.default.createElement(WelcomeProfileBanner, null)) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.banner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bannerText, dangerouslySetInnerHTML: {
                    __html: t('grabYourBonus', {
                        bonus: "".concat(firstDepMaxBonus, " ").concat(defaultCurrency),
                        freespins: firstDepFreespins,
                    }),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, (_b = first === null || first === void 0 ? void 0 : first.descriptions) === null || _b === void 0 ? void 0 : _b.shortTitle),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.buttons, " ").concat((config === null || config === void 0 ? void 0 : config.hideSignUpInProfileMenu) ? styles_module_scss_1.default.buttonsCentered : '') },
                !(config === null || config === void 0 ? void 0 : config.hideSignUpInProfileMenu) && (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "100%", maxWidth: "100%", text: "upper", onClick: openSignUp }, t('signup'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.login, onClick: openSignIn }, t('login')))))));
};
exports.default = UnAuthProfileMenu;
